import { GatewayService } from '../GatewayService';
import { InAppPurchase2 } from '@ionic-native/in-app-purchase-2/ngx';
import { ChaveContratoEnum } from '../ChaveContratoEnum';
import { PhicubeResponse } from '../interface/PhicubeResponse';

export class PlanoProvider {
    static TIPO_PLANO_ACOES = "acoes"
    static TIPO_PLANO_CRIPTOMOEDAS = "criptomoedas"
    static TIPO_PLANO_EUA = "eua"

    static STATUS_COMPRA_EFETUADA = 3
    static STATUS_CANCELAMENTO = 6

    isAdmin = false

    constructor(isAdmin) {
        this.isAdmin = isAdmin
    }

    confirmPurchaseApi(codPlano: String, dadosPagamento, product): Promise<PhicubeResponse> {
        return new GatewayService().requestPost('/api/eduzz/checkout/' + codPlano, {
            edz_cli_apikey: "b40c1d19f7",
            edz_cli_email: dadosPagamento.email,
            edz_cli_taxnumber: dadosPagamento.cpf,
            edz_cli_rsocial: dadosPagamento.nome,
            edz_fat_status: dadosPagamento.status,
            edz_payment_method: "Apple",
            edz_cnt_cod: dadosPagamento.codProduto,
            edz_cnt_titulo: dadosPagamento.tituloProduto,
            edz_obj_apple: product
        })
    }

    associateApple(originalTransactionId, receiptData): Promise<PhicubeResponse> {
        return new GatewayService().requestPost('/api/apple/associate', {
            "original_transaction_id": originalTransactionId,
            "receipt_data": receiptData
        })
    }

    obtemTituloPlanoPorCodigo(codPlano) {
        switch (codPlano) {
            case PlanoProvider.TIPO_PLANO_ACOES: return "Plano Ações 12 meses"
            case PlanoProvider.TIPO_PLANO_CRIPTOMOEDAS: return "Plano Criptomoedas 12 meses"
            case PlanoProvider.TIPO_PLANO_EUA: return "Plano EUA 12 meses"
            default: return ""
        }
    }

    async listPlanos() {
        const plans = [
            {
                idApple: "br.com.phicubeapp.autorenovavel.acoesbolsabrasileira2",
                codPlano: PlanoProvider.TIPO_PLANO_ACOES,
                icon: "../../assets/img/plano-ios/002-analytics-pb.svg",
                name: "",
                desconto_texto: "Aproveite 30% de Desconto",
                preco: "R$ 0",
                period: "anual",
                desconto_color: "#337ab7",
                detalhe_preco: "Anual para 12 meses",
                chavesContrato: [ChaveContratoEnum.CONTRATO_RECOMENDACAO_ACOES],
                caracteristicas: [
                    { descricao: "Receba recomendações de compra e venda" },
                    { descricao: "Análise e Prisma com indicadores PhiCube" },
                    { descricao: "Rastreador inteligente em tempo real" },
                    { descricao: "Monitoramento pela equipe de analistas" }
                ]
            },
            {
                idApple: "br.com.phicubeapp.autorenovavel.acoesbolsaamericana2",
                codPlano: PlanoProvider.TIPO_PLANO_EUA,
                icon: "../../assets/img/plano-ios/010-flag-usa.svg",
                name: "",
                desconto_texto: "Aproveite 30% de Desconto",
                desconto_color: "#ff4141",
                preco: "R$ 0",
                period: "anual",
                detalhe_preco: "Anual para 12 meses",
                chavesContrato: [ChaveContratoEnum.CONTRATO_RECOMENDACAO_EUA],
                caracteristicas: [
                    { descricao: "Receba recomendações de compra e venda" },
                    { descricao: "Análise e Prisma com indicadores PhiCube" },
                    { descricao: "Rastreador inteligente em tempo real" },
                    { descricao: "Monitoramento pela equipe de analistas" }
                ]
            },
            {
                idApple: "br.com.phicubeapp.autorenovavel.criptoativosdigitais2",
                codPlano: PlanoProvider.TIPO_PLANO_CRIPTOMOEDAS,
                icon: "../../assets/img/plano-ios/003-bitcoin-pb.svg",
                name: "",
                desconto_texto: "Aproveite 30% de Desconto",
                preco: "R$ 0",
                desconto_color: "#ffc107",
                period: "anual",
                detalhe_preco: "Anual para 12 meses",
                chavesContrato: [ChaveContratoEnum.CONTRATO_RECOMENDACAO_CRIPTOMOEDAS],
                caracteristicas: [
                    { descricao: "Receba recomendações de compra e venda" },
                    { descricao: "Análise e Prisma com indicadores PhiCube" },
                    { descricao: "Rastreador inteligente em tempo real" },
                    { descricao: "Monitoramento pela equipe de analistas" }
                ]
            }
        ]

        if (this.isAdmin) {
            plans.push({
                idApple: "br.com.phicubeapp.autorenovavel.acoesbolsabrasileiraplus",
                codPlano: PlanoProvider.TIPO_PLANO_ACOES,
                icon: "../../assets/img/plano-ios/002-analytics-pb.svg",
                name: "",
                desconto_texto: "Aproveite 30% de Desconto",
                preco: "R$ 0",
                period: "semanal",
                desconto_color: "#337ab7",
                detalhe_preco: "Semanal para 7 dias",
                chavesContrato: [ChaveContratoEnum.CONTRATO_RECOMENDACAO_ACOES],
                caracteristicas: [
                    { descricao: "Receba recomendações de compra e venda" },
                    { descricao: "Análise e Prisma com indicadores PhiCube" },
                    { descricao: "Rastreador inteligente em tempo real" },
                    { descricao: "Monitoramento pela equipe de analistas" }
                ]
            })
        }

        return plans
    }

    async getCodPlanoPorIdApple(idApple) {
        for (let plan of await this.listPlanos()) {
            if (plan.idApple == idApple) {
                return plan.codPlano
            }
        }
        return ""
    }

    async configPlanosInApp(iap: InAppPurchase2) {
        if (iap.products.length == 0) {
            (await this.listPlanos()).forEach((value, index) => {
                const productId = value.idApple
                // Register Product
                // Set Debug High
                // Register the product with the iap
                iap.register({
                    id: productId,
                    alias: productId,
                    type: iap.PAID_SUBSCRIPTION
                });
            })
            iap.refresh();
        }
    }
}